import { Dispatch, SetStateAction } from 'react'

import {
  AUDIT_LOG_SEARCH_CONDITION_CLEAR,
  AuditLogSearchCondition
} from '@/common/api/modules/auditLog'
import { isSameSearchCondition } from '@/common/api/search'

import Button from '@/components/view/atoms/button/Button'
import Selector, { SelectorSize } from '@/components/view/atoms/selector/Selector'
import SearchConditionAreaContent from '@/components/view/layouts/area/SearchConditionAreaContent'
import SortButtonList from '@/components/view/layouts/button/SortButtonList'

const ACTION_CHOICES = [
  { value: '', name: '全アクション' },
  { value: 'login', name: 'login' },
  { value: 'login_failed', name: 'login_failed' },
  { value: 'logout', name: 'logout' },
  { value: 'create', name: 'create' },
  { value: 'update', name: 'update' },
  { value: 'delete', name: 'delete' },
  { value: 'export', name: 'export' }
]

const dateInputClass =
  'border-secondary bg-surface text-primary focus:border-focus rounded-lg border px-3 py-2 text-xs outline-none'

interface Props {
  condition: AuditLogSearchCondition
  setCondition: Dispatch<SetStateAction<AuditLogSearchCondition>>
}

const AuditLogSearchConditionField = ({ condition, setCondition }: Props) => {
  const isDefault = isSameSearchCondition(condition, AUDIT_LOG_SEARCH_CONDITION_CLEAR)

  return (
    <SearchConditionAreaContent>
      <SortButtonList>
        <Selector
          size={SelectorSize.AUTO}
          name='action'
          choices={ACTION_CHOICES}
          value={condition.action ?? ''}
          onChange={(e) =>
            setCondition((prev) => ({
              ...prev,
              page: 1,
              action: e.target.value || null
            }))
          }
        />
        <input
          type='text'
          placeholder='操作者名'
          className={dateInputClass}
          value={condition.operatorName ?? ''}
          onChange={(e) =>
            setCondition((prev) => ({
              ...prev,
              page: 1,
              operatorName: e.target.value || null
            }))
          }
        />
        <input
          type='date'
          className={dateInputClass}
          value={condition.dateFrom ?? ''}
          onChange={(e) =>
            setCondition((prev) => ({ ...prev, page: 1, dateFrom: e.target.value || null }))
          }
        />
        <span className='text-secondary text-xs'>〜</span>
        <input
          type='date'
          className={dateInputClass}
          value={condition.dateTo ?? ''}
          onChange={(e) =>
            setCondition((prev) => ({ ...prev, page: 1, dateTo: e.target.value || null }))
          }
        />
        <Button
          color='secondary'
          disabled={isDefault}
          onClick={() => setCondition(AUDIT_LOG_SEARCH_CONDITION_CLEAR)}
        >
          条件をリセット
        </Button>
      </SortButtonList>
    </SearchConditionAreaContent>
  )
}

export default AuditLogSearchConditionField
